const breakpoints = ['993px', '1281px', '1441px', '1921px']

// aliases
breakpoints.md = breakpoints[0]
breakpoints.lg = breakpoints[1]
breakpoints.xl = breakpoints[2]
breakpoints.xxl = breakpoints[3]

export { breakpoints }
